export default __webpack_public_path__ + "96a96dffc099bded9e22568192ff310c.svg";